import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.offer) {
            const { offer } = this.props;

            this.state = {
                id: offer.id,
                name: offer.name,
                title: offer.title,
                body: offer.body,
                icon: offer.icon,
                image: offer.image,
                url: offer.url,
                update: true
            };
        }
        else {
            this.state = {
                name: '',
                title: '',
                body: '',
                icon: '',
                image: '',
                url: '',
            };
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />
                    <FieldGroup
                        name="title"
                        label="Title:"
                        onChange={this.handleFieldChange}
                        value={this.state.title}
                        required
                    />
                    <FieldGroup
                        name="body"
                        label="Body:"
                        onChange={this.handleFieldChange}
                        value={this.state.body}
                        required
                    />
                    <FieldGroup
                        name="icon"
                        label="Icon:"
                        onChange={this.handleFieldChange}
                        value={this.state.icon}
                        required
                    />
                    <FieldGroup
                        name="image"
                        label="Image:"
                        onChange={this.handleFieldChange}
                        value={this.state.image}
                        required
                    />
                    <FieldGroup
                        name="url"
                        label="Url:"
                        onChange={this.handleFieldChange}
                        value={this.state.url}
                        required
                    />

                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffers/components/Form/index.js